import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {VatModelService} from '../../Models/Core/vat-model.service';

@Injectable({
  providedIn: 'root'
})
export class VatApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: VatModelService
  ) {
    super(injector);
  }


  /**
   * Obtener el listado de IVA
   *
   */
  public getVat(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getIvas', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
